import { Type } from 'class-transformer';
import {
	IsBoolean,
	IsDate,
	IsEmail,
	IsObject,
	IsOptional,
	IsString,
	IsUUID,
	MaxLength,
	ValidateIf,
} from 'class-validator';
import { IsPastDate } from '../../utils/validators';

export class UpdateUserDto {
	@IsOptional()
	@IsUUID()
	id?: string;

	@IsOptional()
	@IsString()
	@MaxLength(150)
	bio?: string | null;

	@IsOptional()
	@IsString()
	full_name?: string;

	@IsOptional()
	@IsUUID()
	img_parent_id?: string | null;

	@ValidateIf((o: UpdateUserDto) => !!o.img_parent_id)
	@IsOptional()
	@IsObject()
	img_variants?: { [key: string]: string } | null;

	@IsOptional()
	@IsBoolean()
	is_private?: boolean;

	@IsOptional()
	@IsString()
	college?: string | null;

	@IsOptional()
	@IsString()
	country?: string | null;

	@IsOptional()
	@IsObject()
	viewed_popups?: {
		intro?: boolean;
		userInsights?: boolean;
		accepted_latest_terms?: boolean;
		viewed_average_calculation_update?: Record<string, boolean>;
	};

	@IsOptional()
	@Type(() => Date)
	@IsDate()
	@IsPastDate()
	birthday?: Date | null;
}

export class updateAgreementToEmailsDto {
	@IsBoolean()
	does_agree: boolean;

	@IsOptional()
	@IsEmail()
	email?: string;
}
